import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-acs-email-test',
  templateUrl: './acs-email-test.component.html',
  styleUrls: ['./acs-email-test.component.scss'],
})
export class AcsEmailTestComponent implements OnInit {
  toEmail = '';
  subject = 'ACS Email Test';
  plainText =
    'Hello! This email was sent using Azure Communication Services.';
  sending = false;
  error = '';
  responseJson = '';

  constructor(
    private readonly authService: AuthService,
    private readonly localStorage: LocalStorageService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    if (!this.localStorage.authorizationData?.token) {
      void this.router.navigate(['/login'], {
        queryParams: { returnUrl: '/test/acs-email' },
      });
    }
  }

  get canSend(): boolean {
    return (
      !!this.toEmail.trim() &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.toEmail.trim()) &&
      !this.sending
    );
  }

  async sendTestEmail(): Promise<void> {
    this.sending = true;
    this.error = '';
    this.responseJson = '';
    try {
      const result = await firstValueFrom(
        this.authService.sendAcsEmailTest({
          to: this.toEmail.trim().toLowerCase(),
          subject: this.subject.trim() || undefined,
          plainText: this.plainText.trim() || undefined,
        })
      );
      this.responseJson = JSON.stringify(result, null, 2);
      if (result.status && result.status !== 'Succeeded') {
        this.error = `ACS returned status: ${result.status}`;
      }
    } catch (err: unknown) {
      const msg =
        (err as { error?: { message?: string } })?.error?.message ||
        (err instanceof Error ? err.message : 'Send failed');
      this.error = msg;
    } finally {
      this.sending = false;
    }
  }
}
